export default "__VITE_ASSET__Dsu5o9XV__"